/** @type {import("@mui/material").SxProps<Theme>} */

const styles = theme => ({
  modalRoot: {
    [theme.breakpoints.down('sm')]: {
      overflow: 'overlay',
    },
    '& .MuiBackdrop-root': {
      '@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none)': {
        background: theme.palette.primary.boxShadow5Medium,
        backdropFilter: 'blur(4.5px)',
      },
      '@supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none))': {
        background: theme.palette.primary.boxShadow3Medium,
      },
    },
  },
  backCTA: {
    position: 'absolute',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      marginTop: '-6rem',
    },
  },
  closeCTA: {
    position: 'absolute',
    zIndex: 1,
    right: '0px',
    top: '0px',
    padding: '12px',
    [theme.breakpoints.down('sm')]: {
      right: '5px',
      top: '15px',
    },
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'calc(100% - 3.75rem)',
    maxWidth: 634,
    bgcolor: 'background.paper',
    borderRadius: '0.625rem',
    boxShadow: 24,
    paddingBottom: '2.5rem',
    background: theme.palette.primary.contrastText,
    outline: 'none',

    '&::-webkit-scrollbar': {
      width: '0.2rem',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: `inset 0 0 6px ${theme.palette.primary.boxShadowScrollbar}`,
      webkitBoxShadow: `inset 0 0 6px ${theme.palette.primary.boxShadowScrollbar}`,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.errorCTA,
      outline: '0.25rem solid transparent',
      borderRadius: '10rem',
    },

    [theme.breakpoints.up('sm')]: {
      maxHeight: '90vh',
      overflow: 'hidden',
    },
    [theme.breakpoints.down('sm')]: {
      position: 'unset',
      top: 'unset',
      left: 'unset',
      WebkitTransform: 'unset',
      transform: 'unset',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'unset',

      margin: '0.5rem auto 0',
      padding: 0,
      minHeight: 'calc(100vh - 6rem)',
      maxHeight: 'unset',
      width: 'calc(100vw - 1rem)',
      borderRadius: '0.625rem 0.625rem 0rem 0rem',
    },
  },
  modalStyle: {
    width: '100%',
    height: '100%',
    position: 'relative',
    objectFit: 'cover',
    objectPosition: 'top',
  },
  modalImage: {
    // borderTopLeftRadius: '0.625em',
    // borderTopRightRadius: '0.625em',
    objectFit: 'cover',
    borderRadius: '0.625rem 0.625rem 0 0',
  },
  ModalBannerCurve: {
    width: '100%',
    height: { xs: '2.55rem', sm: '2.2rem', lg: '2.23rem' },
    bottom: '-0.0625em',
    position: 'absolute',
  },
  imageAndText: {
    height: '10.3rem',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      maxHeight: 'unset',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '10.938rem',
    },
  },
  iconStyle: {
    height: '10.3rem',
    objectFit: 'cover',

    width: '100%',
    [theme.breakpoints.down('sm')]: {
      borderTopLeftRadius: '10px',
      borderTopRightRadius: '10px',
    },
  },
  descriptionBox: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('sm')]: {
      flexGrow: 1,
    },
  },
  imgIconstyle: {
    display: 'block',
    margin: '0 auto',
    height: '6rem',
    width: 'auto',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      height: '4rem',
    },
  },
  modalheaderstyle: {
    textAlign: 'center',
    color: theme.palette.secondary.mobileActiveToggleBackground,
    padding: '0rem 4rem',
    margin: '1rem 0rem 1rem 0rem',
    lineHeight: 'unset',
    [theme.breakpoints.down('sm')]: {
      padding: '0rem 2rem',
      margin: 0,

      marginTop: '16px',
    },
  },
  aMonthStyle: {
    marginTop: '0px!important',
  },
  textstyle: {
    textAlign: 'center',
    color: theme.palette.secondary.mobileActiveToggleBackground,
    padding: '0rem 2rem',
    margin: '0.5rem 0rem 2.5rem 0rem',

    [theme.breakpoints.down('sm')]: {
      margin: '1rem 0 0 0',
    },
  },
  ctaBox: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '2.5rem',
      padding: '0 1.9rem',
    },
  },
  ctaContainer: {
    padding: '0 2rem',
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      gridRowGap: '1rem',
      display: 'flex',
      flexDirection: 'column',
    },
  },
  altctaContainer: {
    padding: '0 2rem',
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
      gridRowGap: '1rem',
    },
  },
  solidctaContainer: {
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
      gridRowGap: '1rem',
    },
  },
  ctagrid: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      width: 'inherit',
      marginLeft: '0 !important',
    },
  },
  altctagrid: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      marginTop: '1rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  solidctagrid: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0 !important',
      marginLeft: 0,
    },
  },
  ctastyle: {
    border: `0.1875rem solid ${theme.palette.primary.buttonColor}`,
    width: '11.5rem',
    padding: '0.3125rem',
    minHeight: '2.5rem',
    color: theme.palette.primary.buttonColor,

    '&:hover': {
      background: theme.palette.primary.buttonColor,
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: 0,
    },
  },
  altctastyle: {
    padding: '0rem',
    color: theme.palette.primary.buttonColor,
  },
  solidctastyle: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    width: '11.5rem',
    padding: '0.3125rem',
    minHeight: '2.5rem',
    color: theme.palette.secondary.contrastText,
    background: theme.palette.primary.buttonColor,
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
    '&.Mui-disabled': {
      background: `${theme.palette.primary.buttonInactiveColor} !important`,
      color: `${theme.palette.secondary.contrastText} !important `,
      border: 'none !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0.5rem',
    },
  },
});

export default styles;
